import { Box, Typography } from '@mui/material';
import { FC } from 'react';

const FileToLargeToDisplay: FC = () => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      mt={10}
      mb={10}>
      <Typography mb={0.5} color='text.primary'>
        The file is too large to display changes.
      </Typography>
      <Typography mb={0.5} color='text.primary'>
        On making a Pull Request, you can view the changes in the PR details.
      </Typography>
    </Box>
  );
};

export default FileToLargeToDisplay;
